import { render, staticRenderFns } from "./left2.vue?vue&type=template&id=b625a056&scoped=true"
import script from "./left2.vue?vue&type=script&lang=js"
export * from "./left2.vue?vue&type=script&lang=js"
import style0 from "./left2.vue?vue&type=style&index=0&id=b625a056&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b625a056",
  null
  
)

export default component.exports